<div class="cctv-camera">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="">
                    <h4 class="cctv-title">CCTV Camera Status No Video</h4>
                </div>

            </div>
        </div>
    </div>
</div>
<!-------============= search bar  =======================------>

<section class="mis_dropdown">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="dropfilter__flex">
                    <!-- navigation  -->
                    <div class="section" *ngIf="hide">
                        <button (click)="navigateBackward(cctvnovideo[0])" class="btn btn-light backbtn_mb"><span><i
                                    class="fa fa-arrow-left back_btn" aria-hidden="true"></i></span></button>
                    </div>
                    <div class="drop__widthone">
                        <div class="dropsearch_flex">
                            <div class="dropwidth">
                                <select name="dropdown" class="mis_select" id="dropdown"
                                    (change)="onOptionsSelected($event)">
                                    <option value="STATE">State</option>
                                    <option value="CITY">City</option>
                                    <option value="CAMPUS">Campus</option>
                                </select>
                            </div>
                            <div class="searchwidth">
                                <div class="input-group">
                                    <input type="text" class="form-control misinput_control" placeholder="Search"
                                        [(ngModel)]="searchTerm" (keyup)="search($event)">
                                    <div class="input-group-btn">
                                        <button class="btn drop_iconsearch" type="submit">
                                            <i class="fa fa-search" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="dropdown">
                        <button class="dropdown-toggle month_dropshow" type="button" id="dropdownMenuButton1"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <img src="../../assets/image/filter.png" alt="filter" class="cctv_filter">
                        </button>
                        <ul class="dropdown-menu dropdown-menu-right mis_select_show"
                            aria-labelledby="dropdownMenuButton1">
                            <li><a class="dropdown-item">Connected</a></li>
                            <li><a class="dropdown-item">Not Connected</a></li>
                            <li><a class="dropdown-item">Video Streaming</a></li>
                            <li><a class="dropdown-item">Video Not Streaming</a></li>
                        </ul>
                    </div> -->
                </div>
            </div>
            <div class="col-md-12">
                <div class="search_mobshow">
                    <div>
                        <h6 class="mob_searchhd">Search by</h6>
                    </div>
                    <div class="searchitem_scroll">
                        <ul class="search_items">
                            <li><a href="#">Admission no </a></li>
                            <li><a href="#">School</a></li>
                            <li><a href="#">State</a></li>
                            <li><a href="#">Zone</a></li>
                            <li><a href="#">City</a></li>
                            <li><a href="#">Campus</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!--================== state and city ============-->
<div *ngIf="show">
    <section class="section_one">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="state__sec">
                        <ul class="state__list">
                            <div *ngIf="cctvnovideo.length<=0">
                                <section class="section_one">
                                    <!-- <div class="container">
                                        <div class="row">
                                            <div class="col-lg-12"> -->
                                                <div class="cctvcouncelling__sec">
                                                    <div class="councellist__flex">
                                                        <!-- <div class="counceltitle__flex">
                                                            <div>
                                                                <h5 class="councel__name">Streaming</h5>
                                                            </div>
                                                        </div> -->
                                                        <div>
                                                            <div class="nodata_center">
                                                                <figure class="mb-0">
                                                                    <img src="../../../../assets/image/nodata.png"
                                                                        alt="nodata" class="nodata">
                                                                </figure>
                                                                <p class="no_data">No Data Found</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            <!-- </div>
                                        </div>
                                    </div> -->
                                </section>
                            </div>
                            <li *ngFor="let data of cctvnovideo | filter:searchkey:'head1' ">
                                <div class="statelist__flex">
                                    <div class="statetitle__flex">
                                        <div>
                                            <h5 class="state__name">
                                                {{data.head1}}
                                            </h5>
                                        </div>
                                        <div>
                                            <h6 class="state__dvr">Total DVR : <span class="dvr__color"></span>
                                                {{data.totalDvrs}}
                                            </h6>
                                        </div>
                                    </div>
                                    <div class="cctv__colflex">
                                        <div class="cctv__camflex">
                                            <div>
                                                <figure class="mb-0">
                                                    <img src="../../assets/image/cctv.jpg" class="cctv" alt="cctv">
                                                </figure>
                                            </div>
                                            <div>
                                                <h6 class="cctv__title">CCTV Installed</h6>
                                                <h5 class="cctv__number">{{data.totalCamerasInstalled | million}}</h5>
                                            </div>
                                        </div>
                                        <div>
                                            <h6 class="cctv__title">Connected</h6>
                                            <h5 class="cctv__number">{{data.totalConnected | million}}</h5>
                                        </div>
                                        <div>
                                            <h6 class="cctv__title">Not streaming</h6>
                                            <h5 class="cctv__number">{{data.totalVideoNotStreaming | million}}</h5>
                                        </div>
                                        <div>
                                            <h6 class="cctv__title">Streaming</h6>
                                            <h5 class="cctv__number">{{data.totalVideoStreaming | million}}</h5>
                                        </div>
                                        <div>
                                            <h6 class="cctv__title">No Video</h6>
                                            <h5 class="cctv__number">{{data.totalNovideo | million}}</h5>
                                        </div>
                                        <div (click)="navigatertochange(data)">
                                            <figure class="mb-0">
                                                <img src="../../assets/image/rightarrow.png" class="rightarrow"
                                                    alt="rightarrow">
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
<!--================== navitage to right click ====================-->

<div *ngIf="!show">
    <div>
        <app-campus [id]="id"></app-campus>
    </div>
</div>

<!--================== loader ================-->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>